import { Box, Grid } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { postsPerPage } from '../../../utils/getBlogData';
import { blogsPerPage } from '../BlogPage.contants';
import { ArticleItem } from './ArticleItem/ArticleItem.component';
import { StyledSection, StyledInfo } from './Articles.styles';
import type { ArticlesProps } from './Articles.types';

export const Articles = ({ articles }: ArticlesProps) => {
  const observerTarget = useRef<HTMLDivElement>(null);
  const [displayedCount, setDisplayedCount] = useState(blogsPerPage);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setDisplayedCount((prev) => prev + postsPerPage);
        }
      },
      { threshold: 0.1 }
    );

    const currentTarget = observerTarget.current;

    if (currentTarget) {
      observer.observe(currentTarget);
    }

    return () => {
      if (currentTarget) {
        observer.unobserve(currentTarget);
      }
    };
  }, []);

  const displayedArticles = articles.slice(0, displayedCount);

  const hasMore = displayedCount < articles.length;

  if (articles.length === 0) {
    return (
      <StyledSection width="normal">
        <StyledInfo>No articles found.</StyledInfo>
      </StyledSection>
    );
  }

  return (
    <StyledSection width="normal">
      <Grid container spacing={2} pb={4}>
        {displayedArticles.map((article) => (
          <ArticleItem key={article.documentId} article={article} />
        ))}
      </Grid>
      {hasMore && (
        <Box
          ref={observerTarget}
          sx={{
            height: '20px',
            width: '100%',
            mt: 2,
          }}
        />
      )}
    </StyledSection>
  );
};
